<div class="lin-avatar">
  <div
    class="lin-avatar-block"
    [ngClass]="{
      xl: size === AvatarSize.xl,
      lg: size === AvatarSize.lg,
      md: size === AvatarSize.md,
      mds: size === AvatarSize.mds,
      sm: size === AvatarSize.sm,
      xs: size === AvatarSize.xs,
      group: size === AvatarSize.group,
      bg: isShortName
    }"
  >
    @if (isSource) {
    <img [src]="source" alt="avatar" class="lin-avatar-block-img" />
    } @if (isShortName) {
    <span class="lin-avatar-block name">{{ shortName }}</span>
    } @if (isDefault) {
    <img src="assets/images/default_avatar.png" alt="avatar" class="lin-avatar-block-img" />
    }
  </div>
</div>
